const initialState = {
  threads: [],
  contents: {},
  isFetching: false,
  getThreadsError: "",
  getContentsError: ""
};

export default function loginReducer(state=initialState, action) {
  switch (action.type) {
    case 'SEND_REQUEST':
      return {
        ...state,
        isFetching: true,
        getThreadsError: "",
        getContentsError: ""
      };
    case 'GET_THREADS_SUCCESS':
      return {
        ...state,
        threads: action.payload.threads,
        isFetching: false
      };
    case 'GET_THREADS_FAILURE':
      return {
        ...state, isFetching: false,
        getThreadsError: action.payload.error,
      };
    case 'GET_CONTENTS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        contents: Object.assign(state.contents, action.payload.contents)
      };
    case 'GET_CONTENTS_FAILURE':
      return {
        ...state,
        isFetching: false,
        getContentsError: action.payload.error
      };
    default:
      return state;
  }
}
